import { format, parseISO } from 'date-fns'
import { nl } from 'date-fns/locale'

const uren = new Intl.NumberFormat('nl-NL', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 1,
})

const procent = new Intl.NumberFormat('nl-NL', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
})

export function formatUren(waarde: number): string {
  return uren.format(waarde)
}

export function formatUrenMetTeken(waarde: number): string {
  const teken = waarde > 0 ? '+' : ''
  return `${teken}${uren.format(waarde)}`
}

export function formatProcent(waarde: number): string {
  return `${procent.format(waarde)}%`
}

export function formatDatum(iso: string): string {
  return format(parseISO(iso), 'd MMM yyyy', { locale: nl })
}

export function formatKorteDatum(iso: string): string {
  return format(parseISO(iso), 'd MMM', { locale: nl })
}

export function formatPeriode(van: string, tot: string): string {
  return `${formatKorteDatum(van)} tot ${formatDatum(tot)}`
}

export function formatWeken(aantal: number | null): string {
  if (aantal === null) return ''
  return `${aantal} ${aantal === 1 ? 'week' : 'weken'}`
}

export function initialen(naam: string): string {
  return naam
    .split(' ')
    .map((deel) => deel[0])
    .filter(Boolean)
    .slice(0, 2)
    .join('')
    .toUpperCase()
}
